import { BellRing } from 'lucide-react'
import type { CommitmentTopicItem } from '../lib/api'

type ReminderItem = Pick<CommitmentTopicItem,
  'followup_at' | 'status' | 'snooze_until' | 'auto_chase_topic_message_id'
>

export function hasDueFollowup(items: ReminderItem[] | undefined, now = Date.now()): boolean {
  return items?.some((item) => {
    if (!item.auto_chase_topic_message_id || item.status === 'done' || item.status === 'canceled') return false
    const wake = Date.parse(item.followup_at ?? '')
    const snooze = Date.parse(item.snooze_until ?? '')
    return Number.isFinite(wake) && wake <= now && !(Number.isFinite(snooze) && snooze > now)
  }) ?? false
}

export default function CommitmentFollowupBadge({ items, closed, snoozedUntil }: {
  items?: ReminderItem[]
  closed?: boolean
  snoozedUntil?: number | null
}) {
  if (closed || (snoozedUntil ?? 0) * 1000 > Date.now() || !hasDueFollowup(items)) return null
  return (
    <span
      className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-amber-800 dark:text-amber-300"
      data-testid="commitment-followup-due"
    >
      <BellRing size={13} aria-hidden="true" />
      Follow-up due
    </span>
  )
}
